import { Breadcrumbs, BreadcrumbsItem } from '@atlassian/mpac-primitives';
import { useHistory } from '@atlassian/mpac-ui';
import React, { useCallback } from 'react';

import {
  ContentContainer,
  Description,
  Heading,
  HeroBackground,
  HeroContainer,
  Image,
  ImageContainerDesktop,
  ImageContainerMobile,
} from './Hero.styles';

export type HeroProps = {
  backgroundColor: string;
  title: string;
  breadcrumbTitle: string;
  description: string;
  imageUrl: string;
  imageAltText: string;
};

export const Hero = ({
  breadcrumbTitle,
  backgroundColor,
  title,
  description,
  imageUrl,
  imageAltText,
}: HeroProps) => {
  const history = useHistory();

  const handleBreadcrumbsClick = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault();
    history?.push('/');
  };
  const setFocusOnHeading = useCallback(
    (ref) => {
      if (history?.action === 'PUSH' && ref) setTimeout(() => ref?.focus());
    },
    [history?.location]
  );

  const image = <Image alt={imageAltText} src={imageUrl} width="1056" height="1056" />;
  return (
    <HeroBackground backgroundColor={backgroundColor}>
      <HeroContainer>
        <ContentContainer>
          <Breadcrumbs>
            <BreadcrumbsItem href="/" text="Marketplace" onClick={handleBreadcrumbsClick} />
            <BreadcrumbsItem text={breadcrumbTitle} onClick={(e) => e.preventDefault()} />
          </Breadcrumbs>
          <Heading tabIndex={-1} ref={setFocusOnHeading}>
            {title}
          </Heading>
          <ImageContainerMobile>{image}</ImageContainerMobile>
          <Description>{description}</Description>
        </ContentContainer>
        <ImageContainerDesktop>{image}</ImageContainerDesktop>
      </HeroContainer>
    </HeroBackground>
  );
};
